import React from "react";
import classes from "./CustomCheckbox.module.scss";

const CustomCheckbox = ({
  labelText,
  direction = "row",
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div className={classes.customCheckbox}>
      {labelText && direction === "row" && (
        <label for="cudtomCheckbox" className={classes.customCheckbox}>
          {labelText}
        </label>
      )}
      <label className={classes.container}>
        <input
          type="checkbox"
          id="cudtomCheckbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={
            disabled === true
              ? classes.disabledCheckmark + " " + classes.checkmark
              : classes.checkmark
          }
        ></span>
      </label>
      {labelText && direction === "reverse-row" && (
        <label for="cudtomCheckbox" className={classes.customCheckbox}>
          {labelText}
        </label>
      )}
    </div>
  );
};

export default CustomCheckbox;
